export type StatusType = "Concluído" | "Recusado" | "Analise";

export const STATUS_MAP: Record<string, StatusType> = {
  concluido: "Concluído",
  recusado: "Recusado",
  analise: "Analise"
} as const;

export const getStatusKey = (status: StatusType): string => {
  return Object.entries(STATUS_MAP).find(([_, value]) => value === status)?.[0] || '';
};